import AxiosPipeline from '@/services/api/pipeline/axios_pipeline'

export default {
  createRoutineServer: (serverId, routineId) => {
    return AxiosPipeline.put(`server/${serverId}/routine/${routineId}`)
  },

  deleteRoutineServer: (serverId, routineId) => {
    return AxiosPipeline.delete(`server/${serverId}/routine/${routineId}`)
  },
}
